import { Picture as MatchboxPicture } from '@sparkpost/matchbox';

/**
 * Matchbox Picture component.
 * @see https://design.sparkpost.com/components/picture/
 */
const Picture = MatchboxPicture;

export default Picture;
